import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PractitionerCategories } from "types/practitioners/categories";

type Pagination = {
  page: number;
  size: number;
};

type Filtering = {
  category: PractitionerCategories;
  site: string | null;
  search: string | null;
};

export interface InitialState {
  pagination: Pagination;
  filtering: Filtering;
}

const initialState: InitialState = {
  pagination: {
    page: 1,
    size: 10,
  },
  filtering: {
    category: "species",
    site: null,
    search: null,
  },
};

export const practitionerFilters = createSlice({
  name: "practitionerFilters",
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<Partial<Filtering>>) => {
      state.filtering = {
        category: action.payload.category ?? "species",
        site: action.payload.site ?? null,
        search: action.payload.search ?? null,
      };
    },

    setPagination: (state, action: PayloadAction<Partial<Pagination>>) => {
      if (action.payload?.page) {
        state.pagination.page = action.payload.page;
      }
      if (action.payload?.size) {
        state.pagination.size = action.payload.size;
      }
    },
    clearPagination: (state) => {
      state = {
        pagination: {
          page: 1,
          size: 10,
        },
        filtering: {
          category: "species",
          site: null,
          search: null,
        },
      };
    },
  },
});

export const { setFilters, setPagination, clearPagination } =
  practitionerFilters.actions;

export default practitionerFilters.reducer;
